// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/_vue-style-loader@3.1.2@vue-style-loader!./~/_css-loader@0.28.11@css-loader?{"minimize":true,"sourceMap":true}!./~/_vue-loader@12.2.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-572472d2","scoped":false,"hasInlineConfig":false}!./~/_less-loader@4.1.0@less-loader/dist/cjs.js?{"sourceMap":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=styles&index=0!./src/app.vue
// module id = 224
// module chunks = 49